import React, { useRef, useEffect, useState } from 'react';

import { motion } from "framer-motion";

import consts from '../libs/consts';

import Timer from "./Timer";

export default function InputSimple(props) {

    const {
        refs,
        className,
        placeholder,
        type = "text",
        name,
        maxlength,
        value,
        setValue,
        onChange,
        valid,
        label,
        error,
        setError,
        success,
        readOnly,
        disabled,
        onFocus,
        onBlur,
        onKeyDown,
        withButton,
        withButtonPress,
        withText,
        size,
        index,
        subIndex = null,
        full,
        help,
        search,
        style,
        autoComplete = "one-time-code",
        timer = false,
        timerState,
    } = props;

    const inputRef = useRef(null);

    const [classList, setClassList] = useState([]);

    const [t, setT] = useState(timer);
    const [f, setF] = useState(false);

    useEffect(() => {

        setT(timer);

    }, [timer]);

    useEffect(() => {

        if (setError) {
            setError({ ...error, [name]: "" });
        }

    }, [value])

    useEffect(() => {

        let arr = [];

        if (readOnly) arr.push("disable");
        if (withButton) arr.push("withButton");
        if (withText) arr.push("withText");
        if (search) arr.push("withSearch");
        if (error?.[name]) arr.push("error")
        if (className) arr.push(className);

        setClassList(arr);

    }, [readOnly, withButton, withText, search, className, error, name])

    const handleFocus = () => {
        setF(true);

        if (onFocus) onFocus();
    };

    const handleBlur = () => {
        setF(false);

        if (onBlur) onBlur();
    }

    const handleChange = (e) => {

        if (valid === 'num') {
            let num = ""
            if (e.target.value != "")
                num = e.target.value.replace(/\D/g, "") * 1;

            if (onChange) {
                onChange(index, e, num, subIndex);
            } else {
                setValue(num);
            }

        } else if (valid === 'float') {
            const num = e.target.value.replace(/[^0-9.]/g, "");
            // console.log('valid', num + '/' + valid);

            if (onChange) {
                onChange(index, e, num, subIndex);
            } else {
                setValue(num);
            }
        } else {

            if (onChange) {
                onChange(index, e, e.target.value, subIndex);
            } else {
                setValue(e.target.value);
            }
        }
    };


    return (
        <div className='input_box_simple'>
            <input
                ref={refs || inputRef}
                type={type}
                name={name}
                id={name}
                className={classList?.join(" ")}
                placeholder={placeholder}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyDown={(e) => { onKeyDown && onKeyDown(e) }}
                value={value}
                maxLength={maxlength ? maxlength : "255"}
                readOnly={readOnly}
                disabled={disabled}
                autoComplete={autoComplete}
            />
            <motion.div
                className={`clear_btn`}
                initial={consts.loaderVariants.closed}
                animate={(value && f && !readOnly) ? "open" : "closed"}
                variants={consts.loaderVariants}
                onClick={() => {
                    let e = { target: { name: name, value: '' } };
                    handleChange(e);
                }}
            />
        </div>
    )
}